import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import mixpanel from "mixpanel-browser";
import { useDispatch, useSelector } from "react-redux";
import { AuthoritiesEnum, IntegrationTypeEnum } from "~/types/enums";
import { Card, Icon, InputToggle, Link, Picture, Text } from "~/components-shared";
import integrationsActionCreators from "~/store/integrations/actions";
import integrationSelectors from "~/store/integrations/selectors";
import useAbacExt from "~/hooks/abac";
import api from "~/lib/api";
import notionLogo from "~/assets/i/apps/notion_logo.svg";
import styled, { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
const Actions = styled.div`
  position: relative;
  z-index: 2;
`;
const NotionIntegrationCard = _ref => {
  let {
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    userHasOneOf
  } = useAbacExt();
  const theme = useTheme();
  const dispatch = useDispatch();
  const integration = useSelector(integrationSelectors.getIntegrationByType(IntegrationTypeEnum.NOTION));
  const [isExpanded, setIsExpanded] = useState(false);
  const handleToggle = value => {
    if (value) {
      api.notionInstall().then(_ref2 => {
        let {
          path
        } = _ref2;
        const width = 560;
        const height = 700;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;
        window.open(path, "Notion Auth", `width=${width},height=${height},left=${left},top=${top}`);
      });
      setIsExpanded(true);
      mixpanel.track(`Notion Integration – Install`);
    } else if (integration?.id) {
      dispatch(integrationsActionCreators.deleteStarted(integration.id));
      mixpanel.track(`Notion Integration – Uninstall`);
    }
  };
  const handleExpand = () => {
    setIsExpanded(prev => !prev);
    mixpanel.track(`Notion Integration – Expand`);
  };
  return /*#__PURE__*/React.createElement(Card, _extends({
    onClick: userHasOneOf([AuthoritiesEnum.INTEGRATIONS_WRITE, AuthoritiesEnum.ONBOARDING_COMPANY_INTEGRATIONS_WRITE]) && integration ? handleExpand : undefined,
    elemBefore: /*#__PURE__*/React.createElement(Picture, {
      src: notionLogo,
      width: "30px",
      height: "30px",
      border: "squared",
      color: theme.colors.borders.primary,
      s: {
        mr: 2
      }
    }),
    title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      element: "h3",
      display: "inline-block"
    }, "Notion"), integration && userHasOneOf([AuthoritiesEnum.INTEGRATIONS_WRITE, AuthoritiesEnum.ONBOARDING_COMPANY_INTEGRATIONS_WRITE]) && /*#__PURE__*/React.createElement(Icon, {
      scale: 4,
      src: "chevron",
      rotate: isExpanded ? 0 : 180,
      s: {
        ml: 1,
        mb: 1
      }
    })),
    elemAfter: /*#__PURE__*/React.createElement(Actions, null, /*#__PURE__*/React.createElement(InputToggle, {
      display: "inline-block",
      value: !!integration,
      onChange: (value, event) => {
        event.stopPropagation();
        handleToggle(value);
      },
      disabled: !userHasOneOf([AuthoritiesEnum.INTEGRATIONS_WRITE, AuthoritiesEnum.ONBOARDING_COMPANY_INTEGRATIONS_WRITE])
    })),
    collapsed: !integration || !isExpanded,
    s: {
      mb: 3
    }
  }, rest), integration && /*#__PURE__*/React.createElement(Text, {
    weight: "semiBold"
  }, t("CompanyIntegrations.connectedTo"), " ", /*#__PURE__*/React.createElement(Link, {
    href: "https://www.notion.so/",
    underline: true
  }, integration.token.workspace_name), " ", t("CompanyIntegrations.workspace")));
};
export default NotionIntegrationCard;